import { LOCAL_ID_PREFIX } from '../../../../../constants';
import { MedicationsEntity } from '../../../../../store/types/prescription';
import { LAB_TESTS_KIND, MEDICINES_KIND } from '../../../trackSource';

export type FlatMedObj = MedicationsEntity & {
    doseCount?: number;
    medIndex: number;
    tapIndex: number;
    key: string;
};

export const getUncodedDrugs = <T extends MedicationsEntity>(elements: T[]): T[] => {
    const uncodedDrugs = elements.filter(
        (t) =>
            t.id.startsWith(LOCAL_ID_PREFIX) &&
            ((!t.form && !t.dosage_form) || !t.generic_name) &&
            !t.is_otc &&
            !t.med_cat,
    );

    return uncodedDrugs;
};

export const getFlatArray = (
    elements: MedicationsEntity[],
    kind: typeof MEDICINES_KIND | typeof LAB_TESTS_KIND,
    hideFixNowStrip?: boolean,
): FlatMedObj[] => {
    const flatArray = [] as FlatMedObj[];
    const uncodedDrugs = getUncodedDrugs(elements);

    if (!hideFixNowStrip && uncodedDrugs.length && kind === MEDICINES_KIND) {
        flatArray.push({
            id: 'add-drug',
            name: 'add-drug',
            medIndex: -1,
            tapIndex: -1,
            key: `${'add-drug'}-${-1}`,
        });
    }

    const t = elements.reduce((fA, el, currentIndex): FlatMedObj[] => {
        fA.push({
            ...el,
            doseCount: (el.tapering_dose?.length || 0) + 1,
            medIndex: currentIndex,
            tapIndex: -1,
            key: el.id,
        });
        const t = el.tapering_dose?.map((t, tapIndex) => ({
            name: el.name,
            id: el.id,
            dosage_form: el.dosage_form,
            form: el.form,
            product_type: el.product_type,
            generic_name: el.generic_name,
            df_id: el.df_id,

            tapering_dose: undefined,
            soa: el.soa,

            ...t,

            medIndex: currentIndex,
            rowIndex: currentIndex + fA.length + tapIndex,
            tapIndex: tapIndex,
            key: `${el.id}-${currentIndex}`,
        }));
        t && fA.push(...t);
        return fA;
    }, [] as FlatMedObj[]);

    flatArray.push(...t);

    return flatArray;
};
